<template>
	<div class="game-active">
		<div class="video-bg">
			<video class="fixStyle" src="https://dl.cloudpc.cn/video/bg.webm" loop="loop" autoplay="autoplay" muted></video>
			<div class="video-masking"></div>
			<!-- <div class="footer">
				<p>海南君漫科技有限公司</p>
			</div> -->
		</div>
		<div class="footer">
			<p>海南君漫科技有限公司</p>
		</div>
		<!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3478489544&site=qq&menu=yes">
			<div class="right-contact" >
				<span>联系客服</span>
			</div>
		</a> -->
		<!-- <div class="header-download" @click="jumpToDownload">
			多平台下载
		</div> -->
		<div class="active-content">
			<div class="header-logo">
				<img src="@/assets/sbpk/logo.png" alt="">
			</div>
			<div class="header-banner">
				<span @click="imgChangePrev" class="btn-slide">
					<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAulJREFUWAnVmV9u1DAQh5ttKYuKQCriAc7CDTgDUo/BG+KNYyBxAV64QMVZeEEgUVF16bYNv8/yWPm3TRw7XnWkWWeTGfuzM3acSXWQIHVdV3J/JF1LDxu60jFyJ71t6EbH26qqapWzhAajRaCP5fRECqjBTa2HTgB+JfB/U53MLgpYoMdyfCalzCHXquRC4JSTZBKwQI9UG6CM6BLCiAN+M1b5KLC//aeqaNR2rLGR68T177EwuRdCsE9VCSNbUhjpv7sa3Aks2OdyOtnluPD5S0H/GWpjcIb7kd0XLJwnnqHH3AOWIUtW6TDogcHgWVrXWsAyYDVgguWW16oQjZVTzxT8WsA6y8jujOvgFXfwRubn0q9xbs4altbdDsDqCQ+D3OsssJ+lPBW/SefI2rM53wCsf62ezKm549OE/aJrHzvXY/4GNgesHjDRcj1uAenCvo+hG7A99oxh48ItyyW5YY3LMa5ETmDnit2lYIEmlitCgv1sM5a5OEeWhIXHsfKTY3SXhrUBXAPMm0KKlIKF8TAVuCRsMnBpWAdcaea90lHs45h9wbmUpYaHQuo6qyomSU1IPCgBmLfYWPkhhzPplfSd9JO0hNwBTN5gjnyX05m0JPRtCjCdLA2dDFwa2gGTE0iVUiO9ISS20jkTr9vJpaFh3K70Ok0CI8co04EloTewMsIIMz2XLAXtGB2wyMkiTk7ITehZbuhrz9jaB19MAIkx6UJ/iHHu2AY2C4kD9YARzhXL1l4T+q2djCyJ3XD3W5sebYSOVNlLaet8ZAND5myWEB7pMcKC8FPAN+bUAxM0b9AvzGDP5S+LXeMIIWEnvEGIGTu/h5K0a++TQg8YMBmSn73cA6Q1Sbp1MEfcCwnzoFR4PJyEtoH7mCajeW/nzD6hTP9kYI371YP8Vo6UgFXbLFlO83yUadYqcPJvgOfKw7G+AhrW2WZ7Q8ezbrMPE15AGfHBiTvUmD9X7sNiF0LgdLjop9v/42rnowiZ/ycAAAAASUVORK5CYII=" alt="">
				</span>
				<div class="img-box">
					<div class="img" :class="'img'+(Math.abs(((index+1)+imgNum)%5))" v-for="(item,index) in game.gameImg" :key="index" >
						<img :src='item.url' alt="">
					</div>
				</div>
				<span @click="imgChangeNext" class="btn-slide">
					<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAuJJREFUWAnVmV9u1DAQhze7UBYVgVTEA5wFcQHOgLTH4A3xxjGQuAAvXABxFl4QSFRUXbq04fdFthXXSZw4dlYdadZZx38+j8d2MqlWM6Su60rV70u30k1L17pGbqTXLd3r+lBVVa00Sehwsgj0gSo9lAJq4ca2wyAAvxT437GVbLlJwAI9UcXHUtIccqVGzgVOOkpGAQv0nloDFIuWECwO+L9Y41FgM/1naihaNtZZ5D5+/SvmJoMQgn2kRrDskoKl//R12Ass2CeqdNpXsXD+haB/d/XRucKNZY8FC+epYQiYA2AVZMta2g0CMBgMi3fPA1YBdgMW2FR5oQpobjkzTK5dD1i5WLbXr12t8OKzsr5KX4a3ZuXA4s22A9ZIOAxS99kvqsvJ91GaG3pr2NS0f6x6I2nujv95r6KfpKWgHVtjYY2AhTb3uH1bEPrEMLoHFyyTQ0pCN4xrkePYqb7bNchS0PhyhUvwPOsWXxdBQl4J6IaVn5zWbY+tBPQWYN4USklu6E1pYAyRE3oR4JzQm0or77laTDmOAZkqH1ThjfRS+kr6XTpFalziTgnAvMUuIW3r7tThVOvCeAMwcYPSchv2W2KH10sA54JljMWBc8I64H3i9MSq5Yalvz0ucZDmXnglYGE8rPU6TQAjp5VLwApxtYcVCyNs5DmkFCxsDWMDLHKiiKMDcj0jKwl7ZRi95+DzHpAx2e9UyB65O12n7rN9fTk26xIrjQALp/rya9VlynbS3LD4rpt976FHD0IEUp5JvXz9j4kNoqQct0NtsyH8ELALwwZgguYN+ulQKwve+2l91/bpXMJmmALOZ2z+EVLCrsEnhQAYMBUkPntxBEjbJeHWzhhx4BK2Bqnc4+4EtC248WkimoODs+VnpPM/GdjOze5BfGtr8zKnbKd5Psq0wQRO/A1w0hzC/gqo22djjSZNs3ETYl1YvHPhDnTMUxcWLf9h8TaEwBnwop9u/wPXdeij1GDZ6AAAAABJRU5ErkJggg==" alt="">
				</span>
			</div>
			<h2 class="active-des">
				免费体验、即点即玩、<span class="color-yellow">享受专属存档</span>	
			</h2>
			<h3 class="active-txt">
				云游戏、多平台、秒玩赛博朋克2077
			</h3>
			<!-- <div class="active-price">
				<div class="price-box">
					<div class="discount">
						<p>限时</p>
						<p>-70%</p>
					</div>
					<div class="right">
						<div class="discount-price">
							<p>￥</p>
							<p>30</p>
						</div>
						<div class="old-price">
							<p>￥</p>
							<p>100</p>
						</div>
					</div>
				</div>
			</div> -->
			<!-- <div class="buy-btn" @click="handleBuy">立即购买</div> -->
			<div class="active-footer">
				<div class="price">
					<span class="money">￥48</span>
					<span class="txt">无限畅玩</span>
				</div>
				<div class="buy btn"  @click="handleBuy">立即购买</div>
				<div class="play btn" @click="isSelectShow=true">限时免费体验</div>	
			</div>
		</div>
		
		<!-- <div class="footer">
			<p>海南君漫科技有限公司</p>
		</div> -->

		<LoginDialog @openPay="getOpenOrder()"></LoginDialog>

		<div class="dialog-wrapper" v-show="isPayShow">
			<div class="pay-dialog">
				<div class="header">
					<p>赛博朋克2077</p>
					<span @click="isPayShow=false">
						<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
					</span>
				</div>
				<div class="content">
					<div class="loading-content" v-show="isPayLoadShow">
						<i class="el-icon-loading"></i>
					</div>
					<div class="left">
						<ul>
							<li v-for="(item,index) in payList" :key="index" @click="selectPay(item,index)" :class="{'is-select':paySelectIndex==index}">
								<span>
									<img :src="item.img" alt="" >
								</span>
								{{item.name}}
								<img src="@/assets/game-active/gou.png" alt="" v-show="paySelectIndex==index" class="select-gou">
							</li>
						</ul>
					</div>
					<div class="center">
						<div class="qrcode" id="qrcode"></div>
					</div>
					<div class="right">
						<p>扫码支付</p>
						<p>￥48</p>
					</div>
				</div>
				
			</div>
		</div>

		<div class="dialog-wrapper" v-show="isSelectShow">
			<div class="select-dialog">
				<div class="header">
					<p>选择试玩平台</p>
					<img src="@/assets/sbpk/close.png" alt="" class="close" @click="isSelectShow=false">
				</div>
				<div class="content">
					<div class="item" @click="handleJumpUrl('phone')">
						<div class="code">
							<p>手机端扫码下载</p>
							<img src="@/assets/sbpk/qrCode.png"  alt="">
						</div>
					</div>
					<div class="item" data-agl-cvt='6' @click="handleJumpUrl('web')"></div>
					<div class="item" data-agl-cvt='6' @click="handleJumpUrl('win')"></div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
	// import Swiper from 'swiper';
	// import 'swiper/swiper-bundle.min.css';
	window._agl = window._agl || [];
	(function () {
		window._agl.push(
			['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
		);
		(function () {
				var agl = document.createElement('script');
				agl.type = 'text/javascript';
				agl.async = true;
				agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(agl, s);
		})();
	})();
	import LoginDialog from '@/components/login';
	import {Message} from 'element-ui';
	import QRCode from 'qrcodejs2'
	export default {
		name: 'sbpk',
		components: {
			// swiper,
			// swiperSlide
			LoginDialog
		},
		data() {
			return {
				game:{
					gameName:"赛博朋克2077",
					gameImg:[
						{url:require("@/assets/sbpk/1.jpg")},
						{url:require("@/assets/sbpk/2.jpg")},
						{url:require("@/assets/sbpk/3.jpg")},
						{url:require("@/assets/sbpk/4.jpg")},
						{url:require("@/assets/sbpk/5.jpg")}
					],
					// gameVideo:require("@/assets/sbpk/bg.webm"),
				},
				imgTimer:null,
				imgNum:1,
				imgBtnTimer:null,
				isPayShow:false,
				usreInfo:{},
				Paymen:'wxpay',
				isPayLoadShow:false,
				payList:[
					{
						name:"微信",
						img:require("@/assets/game-active/pay-wx.png"),
						id:"wxpay"
					},
					{
						name:"支付宝",
						img:require("@/assets/game-active/pay-ali.png"),
						id:"alipay"
					},
				],
				paySelectIndex:0,
				payTimer:null,
				payTimerCount:0,
				channel:"web",

				isSelectShow:false
			}
		},
		computed: {
			// swiper() {
			// 	return this.$refs.mySwiper.swiper
			// }
		},
		created() {
			document.getElementsByTagName("body")[0].style.minWidth="100%"
			document.getElementsByTagName("body")[0].style.backgroundColor="#000"

			let that=this
			that.getLoginInfo()
		},
		mounted(){
			let that=this
			that.imgChange();
			that.$bus.$on('openOrder',()=>{
				that.getPayOrder()
				that.isPayShow=true
				that.$utils.Burying({act:'loginActiveGameSBPK',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
			})

			if(that.$utils.checkLogin()){
				that.$utils.Burying({act:'welcomeActiveGameSBPK',user_attribute:'old',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
			}else{
				that.$utils.Burying({act:'welcomeActiveGameSBPK',user_attribute:'new',operating_system:'web'});
			}

			// sessionStorage.setItem("channel",that.channel)

			that.channel=sessionStorage['channel']||'web'
		},
		methods: {
			imgChange(){
				let that=this
				clearInterval(that.imgTimer)
				that.imgTimer=setInterval(()=>{
					that.imgNum++
				},3000)
			},
			imgChangePrev(){
				let that=this
				that.imgNum--
				that.imgChange()
			},
			imgChangeNext(){
				let that=this
				that.imgNum++
				that.imgChange()
			},
			handleBuy(){
				let that = this;
				if(that.$utils.checkLogin()){
					that.$utils.Burying({act:'clickBuyActiveGameSBPK',user_attribute:'old',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
				}else{
					that.$utils.Burying({act:'clickBuyActiveGameSBPK',user_attribute:'new',operating_system:'web'});
				}
				if(!that.$utils.checkLogin()){
					that.$bus.$emit('loginDialogShow',true);
				}else{
					that.getPayOrder()
					that.isPayShow=true
				}
			},
			getLoginInfo(){
				let that = this;
				if(!localStorage['login']||localStorage['login']==null)return;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url,{},)
				.then(res=>{
					if(res.data){
						let obj = res.data;
						let str = res.data.phone;
						
						obj.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
						obj.surplus_coin = res.data.my_coin - res.data.used_coin + res.data.cy_count;
						obj.tota_time = obj.surplus_coin/5*60 + obj.free_time
						that.usreInfo = obj;
						that.$set(that.usreInfo,obj);
						sessionStorage.setItem('userInfo',JSON.stringify(res.data));
					}else{
						// token 过期 默认清除登录信息 或者被其他设备登录时需要下线
						// localStorage.setItem('singleLogin',true);
						that.loginOut();
					}
				})
				.catch(err=>{
					console.error(err);
				})
			},
			loginOut(){
				let that = this;
				localStorage.removeItem('login');
				that.usreInfo = {};
				that.$set(that.usreInfo,{});
			},
			getPayOrder(){
				let that=this
				that.isPayLoadShow=true
				let url = 'api/v1/cloud_pc/app/pay';
				that.$req.post(url,{
					"terminal": "WEB", // 终端来源 Android/IOS/PC/WEB
					"channel": that.Paymen, //支付渠道  alipay、wxpay、paypal(暂不支付)
					"method": "qr_code", //web(PC 浏览器)、wap（手机浏览器(支付宝))、app(生成支付参数，用于 App 上调用相关的 SDK 使用(支付宝、微信支付))、qr_code(生成收款二维码，供用户扫码进行支付(支付宝、微信支付))、f2f(扫描用户的付款码进行收款)
					"product_id": 116, // 商品id,自定义金额时id为0
				}).then(res=>{
					if (res.code === 0 && res.data) {
						let ele = 'qrcode';
						document.getElementById(ele).innerHTML = '';
						var qrcode = new QRCode(document.getElementById(ele), {
							width: 152,
							height: 152
						});
						let value = res.data.url
						qrcode.makeCode(value)
						// clearInterval(that.payTimer)
						that.payTimer=setInterval(()=>{
							that.payTimerCount++
							let query = {
								"channel": that.Paymen,
								"trade_no": "",
								"out_trade_no": res.data.order_no
							};
							that.getPayStatus(query);
						},3000)
					}else{
						Message.error(res.data.msg);
					}
					that.isPayLoadShow=false
				}).catch(err=>{
					console.log(err)
					Message.error(err.data.msg)
					that.isPayLoadShow=false
				})
			},
			selectPay(item,key){
				let that=this
				if(that.paySelectIndex!=key){
					that.paySelectIndex=key
					that.Paymen=item.id
					that.getPayOrder()
				}
			},
			getPayStatus(query){
				let that = this;
				let url = 'api/v1/cloud_pc/app/pay/query';
				that.$req.post(url,query)
				.then(res=>{
					if (res.code === 0 && res.data) {
						Message.success("支付成功,准备跳转...")
						that.$utils.Burying({act:'payActiveGameSuccessSBPK',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
						clearInterval(that.payTimer)
						setTimeout(()=>{
							// var newWindow = window.open("about:blank")
							// newWindow.location = window.origin+"/gameDetail.html?gameId=280&channel="+that.channel
							// window.open(window.origin+"/gameDetail.html?gameId=280&channel="+that.channel)]
							window.location = window.origin+"/gameDetail.html?gameId=280&channel="+that.channel
							// that.$router.push({path:'/gameDetail.html',query:{gameId:'280',channel:that.channel}});
							// that.$bus.$emit('setActiveIndex',3);
							// clearInterval(that.payTimer)
						},2000)
					}else{
						// window.location = window.origin+"/gameDetail.html?gameId=280&channel="+that.channel
						// that.$router.push({path:'/gameDetail.html',query:{gameId:'280',channel:that.channel}});
						// that.$bus.$emit('setActiveIndex',3);
						// clearInterval(that.payTimer)
						// window.location = window.origin+"/gameDetail?gameId=280&channel="+that.channel
						// var newWindow = window.open("about:blank")
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			jumpToDownload(){
				let that=this
				// window.open(window.origin+"/download.html?channel="+that.channel)
				that.$router.push({path:'/download.html',query:{channel:that.channel}});
				that.$bus.$emit('setActiveIndex',3);
				if(that.$utils.checkLogin()){
					that.$utils.Burying({act:'activeGameJumpDownloadSBPK',user_attribute:'old',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
				}else{
					that.$utils.Burying({act:'activeGameJumpDownloadSBPK',user_attribute:'new',operating_system:'web'});
				}
			},
			handleJumpUrl(type){
				if(type=="web"){
					window.open('https://www.cloudpc.cn/index.html#/gameDetail.html?gameId=280')
					this.$utils.Burying({act:'activeGameSBPKToWeb',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
				}else if(type=="win"){
					window.location.href='https://dl.tlhcxm.top/PC/pangda/pangdayunyou_pc_official.exe'
					this.$utils.Burying({act:'activeGameSBPKToWin',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
				}
			}
		},
		// watch: {
		// 	'$route':function(to,from){
		// 		let that  =  this;
		// 	}
		// }
	}
</script>
<style lang="less" scoped>
	p,span{margin: 0;}
	ul,li{ padding:0;margin:0;list-style:none}
	.game-active{
		// margin-top:-80px;
		text-align: center;
		background-color: #000;
		min-width:1500px;
		position: absolute;
		top:0;
		width: 100%;
		.video-bg{
			max-height: 940px;
			overflow: hidden;
			padding-bottom:12px;
			.fixStyle{
				// position: fixed;
				top:0;
				right: 0;
				bottom: 0;
				max-width: 100%;
				// padding-bottom:60px; 
				background-color: #000;
				width: auto;
				height: auto; 
				z-index: -100;
				width: 100%;
				max-height: 100%; 
				// padding-bottom: 12px;
				// min-height: 980px;
				-webkit-filter: grayscale(20%);
			}
			.video-masking{
				position: fixed;
				min-width: 100%;
				min-height: 100%; 
				width: auto;
				height: auto; 
				// z-index: -99;
				background-color: rgba(0,0,0,0.5); 
				top:0;
			}
		}
		.active-content{
			position: absolute;
			top:0;
			left: 50%;
			transform: translate(-50%,0);			
		}
		.header-logo{
			width: 1200px;
			margin: 0px auto;
			z-index: 2;
			text-align: left;
			padding-top: 2%;
			img{
				width: 150px;
				// position: absolute;
			}
		}
		.header-download{
			background-color: rgb(255, 202, 40);
			border-color: rgb(255, 202, 40);
			height: 48px;
			width: 150px;
			line-height: 48px;
			font-size: 18px;
			color: rgb(0, 0, 0);
			font-weight: 600;
			position: absolute;
			right: 10px;
			top: 15px;
			border-radius: 4px;
			cursor: pointer;
			text-align: center;
		}
		.right-contact{
			position: fixed;
			right: 0px;
			top: 35%;
			width: 115px;
			height: 50px;
			background-color: rgb(255, 202, 40);
			border-top-left-radius: 30px;
			border-bottom-left-radius: 30px;
			z-index: 5;
			cursor: pointer;
			text-align: center;
			span{
				display: block;
				width: 100%;
				height: 100%;
				background: url(data:image/png;base64,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) 10px center no-repeat;
				padding-left: 18px;
				color: rgb(0, 0, 0);
				font-size: 16px;
				line-height: 50px;
			}
		}
		.header-banner{
			display: flex;
			align-items: center;
			justify-content: center;
			width: 1200px;
			height: 400px;
			position: relative;
			left: 50%;
			transform: translate(-50%,0);
			// margin-top: -64px;
			.img-box{
				display: flex;
				flex-wrap: nowrap;
				position: relative;
				width: 100%;
				height: 100%;
				margin-top: 45px;
				z-index: 1;
				.img{
					display: flex;
					-webkit-box-align: center;
					align-items: center;
					-webkit-box-pack: center;
					justify-content: center;
					position: absolute;
					img{
						max-height: 100%;
						max-width: 100%;
						width: 100%;
						height: 100%;
					}
				}
				.img0{
					width: 404px;
					height: 218px;
					left: 20px;
					top: 61px;
					z-index: 1;
					transition: all 0.5s ease 0s;
				}
				.img1{
					width: 504px;
					height: 272px;
					left: 90px;
					top: 34px;
					z-index: 2;
					transition: all 0.5s ease 0s;
				}
				.img2{
					width: 630px;
					height: 340px;
					left: 240px;
					z-index: 3;
					top: 0px;
					transition: all 0.5s ease 0s;
				}
				.img3{
					width: 504px;
					height: 272px;
					left: 520px;
					top: 34px;
					z-index: 2;
					transition: all 0.5s ease 0s;
				}
				.img4{
					width: 404px;
					height: 218px;
					left: 695px;
					top: 61px;
					z-index: 1;
					transition: all 0.5s ease 0s;
				}
			}
			.btn-slide{
				width: 44px;
				height: 44px;
				position: relative;
				cursor: pointer;
			}
		}
		.active-des{
			font-size: 58px;
			font-weight: 700;
			color: rgb(255, 255, 255);
			margin-top:10px;
			margin-bottom:30px;
			text-align: center;
			.color-yellow{
				color:#FFE800;
			}
		}
		.active-txt{
			font-size: 38px;
			font-weight: 700;
			color: rgb(255, 255, 255);
			margin-top:0;
			margin-bottom:40px;
			text-align: center;
			background: url("../assets/sbpk/bg-gray.png") 100% 100% no-repeat;
			background-size: 100% 100%;
			display: initial;
			width: auto;
			padding: 10px 30px;
		}
		.active-footer{
			background-color: rgba(0,0,0,0.7);
			display: inline-flex;
			align-items: center;
			padding: 8px 30px;
			margin-top: 50px;
			.price{
				font-weight:bolder;
				display: flex;
				flex-direction: column;
				.money{
					font-size: 54px;
					color:#FFE800;
					line-height: 70px;
				}
				.txt{
					font-size: 24px;
					color:#fff;
					line-height: 30px;
				}
			}
			.btn{
				width: 200px;
				height: 70px;
				line-height: 70px;
				font-size: 26px;
				font-weight: bolder;
				cursor: pointer;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				background-position: 100% 100%;
			}
			.buy{
				color:#000;
				background-image: url("../assets/sbpk/btn-yellow.png");
				margin-left: 40px;
			}
			.play{
				margin-left: 50px;
				color:#fff;
				background-image: url("../assets/sbpk/btn-blue.png");
			}
		}
		.active-price{
			display: flex;
			justify-content: center;
			.price-box{
				padding-top: 2px;
				padding-bottom: 2px;
				padding-right: 2px;
				border: none;
				height: 96px;
				display: flex;
				background-color: rgb(255, 190, 67);
				.discount{
					width: 130px;
					text-align: center;
					display: flex;
					flex-direction: column;
					-webkit-box-pack: center;
					justify-content: center;
					align-items: center;
					height: 100%;
					p{
						font-size: 24px;
						height: 24px;
						line-height: 24px;
						color: rgb(0, 0, 0);
						margin: 0;
					}
					p:nth-child(1){
						font-size: 24px;
						height: 24px;
						line-height: 24px;
						margin-bottom: 10px;
					}
					p:nth-child(2){
						height: 33px;
						line-height: 33px;
						font-size: 33px;
						font-weight: 600;
					}
				}
				.right{
					background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWsAAABgCAYAAADb9lMPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM2MCwgMjAyMC8wMi8xMy0wMTowNzoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEQ1MjM3OTRBM0Y0MTFFQUFGNUVBNUY1QjQ3RkFGNzYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEQ1MjM3OTVBM0Y0MTFFQUFGNUVBNUY1QjQ3RkFGNzYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4RDUyMzc5MkEzRjQxMUVBQUY1RUE1RjVCNDdGQUY3NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4RDUyMzc5M0EzRjQxMUVBQUY1RUE1RjVCNDdGQUY3NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjcsJ88AAAF4SURBVHja7NYhDsJQFETRQlC4vyeq2Sp41oVtv6lEksw05yRvAyNu3mWMsS0ARLuaAECsARBrALEGQKwBEGsAsQZArAEQawCxBkCsAcQaALEGQKwBxBoAsQZArAHEGgCxBkCsAcQaALEGEGsAxBoAsQYQawDEGgCxBhBrAMQaQKwBEGsAxBrg3LH+mAEgP9ZPwQbIj/VXsAHyY70INkBHrAUboCTWgg1QEmvBBiiJtWADlMRasAFKYi3YACWxFmyAklgLNkBJrA+byQByY32f95q3mgwgM9ZCDRAea6EGCI+1UAOEx1qoAYLcfoT6Pe9hHoDMz1qoAcJjLdQA4bEWaoDwWAs1QEGshRqgINZCDVAQawDEGgCxBhBrAMQaALEGEGsAxBoAsQYQawDEGkCsARBrAMQaQKwBEGsAxBpArAEQawCxBkCsARBrALEGQKwBEGsAsQZArAEQawCxBkCsAcQaALEGQKwBxBoAsQZArAHEGoC/2gUYAH4+I/O9AMigAAAAAElFTkSuQmCC) center center / 100% 100% no-repeat;
					display: flex;
					padding-left: 30px;
					.discount-price{
						font-size: 64px;
						display: flex;
						-webkit-box-pack: center;
						justify-content: center;
						align-items: flex-end;
						font-weight: 700;
						color: rgb(255, 190, 67);
						p:nth-child(1){
							margin-bottom: 8px;
							line-height: 49px;
							height: 49px;
							font-size: 64px;
						}
						p:nth-child(2){
							margin-bottom: 8px;
							line-height: 74px;
							height: 74px;
							font-size: 96px;
						}

					}
					.old-price{
						font-size: 36px;
						display: flex;
						-webkit-box-pack: center;
						justify-content: center;
						-webkit-box-align: center;
						align-items: center;
						padding: 0px 20px;
						color: rgb(51, 51, 51);
						p:nth-child(1){
							// margin-bottom: 0px;
							font-size: 36px;
							top: 3px;
						}
						p:nth-child(2){
							font-size: 48px;
							font-weight: 700;
							text-decoration: line-through;
							// margin-bottom: 0px;
						}
					}
				}
			}
		}
		.buy-btn{
			height: 77px;
			background-color: rgb(255, 190, 67);
			border: none;
			position: relative;
			font-size: 36px;
			color: rgb(0, 0, 0);
			line-height: 77px;
			padding: 0px;
			width: 366px ;
			border-radius: 4px;
			font-weight: 600;
			z-index: 99;
			display: block;
			margin: 0 auto;
			margin-top: 30px;
			cursor: pointer;
			// margin-bottom:68px;
			text-align: center;
		}
		.footer{
			background: rgb(17, 17, 17);
			padding: 10px 0px;
			// position: fixed;
			// bottom:0;
			width: 100%;
			text-align: center;
			p{
				margin: 0;
				color:#fff;
			}
		}
		.dialog-wrapper{
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5);
			position: fixed;
			top: 0;
			left: 0;
			z-index: 99;
			.pay-dialog{
				position:fixed;
				top:40%;
				left: 50%;
				transform: translate(-50%,-50%);
				background-color: #fff;
				width: 500px;
				border-radius: 5px;
				.header{
					padding: 16px 24px;
					position: relative;
					p{
						font-size: 18px;
						text-align: center;
					}
					span{
						position: fixed;
						right: 24px;
						top:20px;
						line-height: 18px;
						cursor: pointer;
					}
				}
				.content{
					margin: 24px;
					display: flex;
					background-color: #f4f4f4;
					justify-content: center;
					align-items: center;
					padding: 53px 0px;
					position: relative;
					.loading-content{
						position: absolute;
						width: 100%;
						height: 100%;
						background-color: rgba(255,255,255,0.5);
						display: flex;
						align-items: center;
						justify-content: center;
						.el-icon-loading{
							font-size: 50px;
						}
					}
					.left{
						ul{
							li{

								display: flex;
								border:1px solid #d9d9d9;
								padding: 12px 15px;
								cursor: pointer;
								margin: 20px 0;
								font-size: 14px;
								position: relative;
								span{
									margin-right: 4px;
									img{
										width: 20px;
									}
								}
								.select-gou{
									position: absolute;
									right: 0;
									bottom:0;
								}
							}
							.is-select{
								border:1px solid rgb(255, 111, 0);
							}
						}
					}
					.center{
						margin: auto 25px;
						.qrcode{
							width: 152px;
							height: 152px;
						}
					}
					.right{
						display: flex;
						flex-direction: column;
						// width: 98px;
						p:nth-child(1){
							font-size: 14px;
							margin-bottom: 16px;
						}
						p:nth-child(2){
							font-size: 24px;
							color:rgb(255, 111, 0);
						}
					}
				}
			}
			.select-dialog{
				position:fixed;
				top:40%;
				left: 50%;
				transform: translate(-50%,-50%);
				background-color: rgba(0,0,0,0.9);
				width: 458px;
				height: 258px;
				border:1px solid #FAEE51;
				.header{
					margin-top: 23px;
					margin-left: 30px;
					display: flex;
					p{
						color:#FAEE51;
						font-size: 20px;
						font-weight: bolder;
					}
					.close{
						width: 50px;
						position: absolute;
						top: 18px;
						right: 18px;
						cursor: pointer;
					}
				}
				.content{
					display: flex;
					padding: 0 40px;
					justify-content: space-between;
					margin-top: 56px;
					.item{
						width: 120px;
						height: 100px;
						background-size: 100% 100%;
						background-repeat: no-repeat;
						background-position: 100% 100%;
						cursor: pointer;
						position: relative;
						.code{
							display: none;
							width: 220px;
							height: 220px;
							background-color: #fff;
							position: absolute;
							top: 110px;
							left: 0;
							p{
								font-weight: bold;
								margin-top: 20px;
							}
							img{
								width: 140px;
								height: 140px;
								margin-top: 16px;
							}
						}
						.code:hover{
							display: block;
						}
					}
					.item:nth-child(1){
						background-image: url("../assets/sbpk/phone-normal.png");
					}
					.item:nth-child(2){
						background-image: url("../assets/sbpk/web-normal.png");
					}
					.item:nth-child(3){
						background-image: url("../assets/sbpk/win-normal.png");
					}
					.item:nth-child(1):hover{
						background-image: url("../assets/sbpk/phone-hover.png");
						.code{
							display: block;
						}
					}
					.item:nth-child(2):hover{
						background-image: url("../assets/sbpk/web-hover.png");
					}
					.item:nth-child(3):hover{
						background-image: url("../assets/sbpk/win-hover.png");
					}
				}
			}
		}
		
	}
</style>
